export const regexPattern = {
  email: /[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$/,
  password: /(?=.*\d)(?=.*[a-z]).{8,}/,
};
